
"use strict";

var zeropad = '0000000000000000000';

/**
 * Return padded number with zeroes
 *
 * NOTE: length should not be > 20
 *
 * @param {number} number
 * @param {number} length
 * @return {string}
**/
module.exports = function(number, length) {
  var str = String(number)
    , pad = length - str.length;

  if (pad > 0) str = zeropad.substr(0, pad) + str;

  return str;
};
